import React, { useEffect, useState } from "react";
import { MDBInput } from "mdb-react-ui-kit";
// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Row,
  UncontrolledTooltip,
  Col,
  CustomInput,
} from "reactstrap";
import axios from "axios";
import { SMS_CAMPEIGN_SAVE, CHANNEL_CLIENT_CHNLTYPE,FETCH_GROUP_NAMES } from "../../constants";
import SampleCSV from "./sms.csv";
import NotificationAlert from "react-notification-alert";
import moment from "moment";
import LoadingScreen from "react-loading-screen";
import logo from "../../assets/img/logo.png";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import apiService from "../../variables/apiService";

const initialValues = {
  contactGroup:"",
  name: "",
  date: moment().format("YYYY-MM-DD HH:mm A"),
  templateid: "",
  senderid: "",
  type: "",
  message: "",
  description: "",
  mobile_numbers: "",
  peid: "",
  file:"",
  priority1: {
    templateid: "",
    channel: "",
    senderid: "",
  },
  priority2: {
    templateid: "",
    channel: "",
    senderid: "",
  },
  priority3: {
    templateid: "",
    channel: "",
    senderid: "",
  },
  priority4: {
    templateid: "",
    channel: "",
    senderid: "",
  },
};
var channels = [
  {
    value: "",
    label: "Select Channel",
    isDisabled: true,
  },
  { value: "Whatsapp", label: "Whatsapp" },
  { value: "Email", label: "Email" },
  { value: "RCS", label: "RCS" },
  { value: "IVR", label: "IVR" },

];

let groups = [];
let templates = [];
let senderids = [];

let emailtemplates = [];
let emailsenderids = [];

let rcstemplates = [];
let rcssenderids = [];

let whatsapptemplates = [];
let whatsappsenderids = [];

let ivrtemplates = [];
let ivrsenderids = [];

let userObj = localStorage.getItem("user");
let user = JSON.parse(userObj);
const Mycampaigns = () => {
  const [smsCampaign, setsmsCampaign] = useState(initialValues);
  const notificationAlertRef = React.useRef(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [channel, setChannel] = useState([]);
  const [channelemail, setChannelemail] = useState([]);
  const [channelwhatsapp, setChannelwhatsapp] = useState([]);
  const [channelrcs, setChannelrcs] = useState([]);
  const [channelivr, setChannelivr] = useState([]);
  const [file, setFile] = useState(null);
  const [ismanual,setIsManual] = useState(0)


  const [errorhandle, setErrorHandle] = useState();
  const [iscalbck, setiscalbck] = useState(false);
  const [error, setError] = useState({
    error: "",
    iserror: false,
  });
  var filepath = "";
  useEffect(() => {
    fetchChanelsbyClient();
    fetchEmailChanelsbyClient();
    fetchWhatsappChanelsbyClient();
    fetchIvrChanelsbyClient();
    fetchRcsChanelsbyClient();
    viewGroupList();

  }, []);


  const viewGroupList = (pageNo) => {
    let lcObj = localStorage.getItem("user");
    let lclStrge = JSON.parse(lcObj);
    let clientid=lclStrge?.client;
    let user_id=lclStrge?.user_id;

    apiService
      .getData(`${FETCH_GROUP_NAMES}?user_id=${user_id}`)
      .then((response) => {
        groups=[]
        response?.data?.message?.map((group,i)=>{
          
          group?.name&&groups.push({ value:group?.name, label: group?.name })
         
       })
        setIsLoading(false)
      })
      .catch((error) => {
        console.log("????", error);
      });
  };

  //Fetching Template by SMS Channel

  const fetchChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "sms",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await apiService
        .postData(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          templates = [];
          const chnlObj = res?.data[0];

          setChannel(res?.data);
          setsmsCampaign({ ...smsCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              templates.push({ value: item?.template, label: item?.name?item?.template+" ( "+item?.name+")" :item?.template});
          });

          setIsLoading(false);
        })
        .catch((e) => {
          setIsLoading(false);
          let options = {};
          options = {
            place: "tr",
            message:"Templates Not Found",
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };

  //Fetching Template by Email Channel

  const fetchEmailChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "email",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await apiService
        .postData(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          emailtemplates = [];
          const chnlObj = res?.data[0];
       
          setChannelemail(res?.data);
        //  setsmsCampaign({ ...smsCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              emailtemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          // options = {
          //   place: "tr",
          //   message: "Templates Not Found",
          //   type: "warning",
          //   autoDismiss: 2,
          // };
          // notificationAlertRef?.current?.notificationAlert(options);
        }));
  };

   //Fetching Template by Whatsapp Channel

   const fetchWhatsappChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "whatsapp",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await apiService
        .postData(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          whatsapptemplates = [];
          const chnlObj = res?.data[0];

          setChannelwhatsapp(res?.data);
        //  setsmsCampaign({ ...smsCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              whatsapptemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          // options = {
          //   place: "tr",
          //   message: "Templates Not Found",
          //   type: "warning",
          //   autoDismiss: 2,
          // };
          // notificationAlertRef?.current?.notificationAlert(options);
        }));
  };


   //Fetching Template by RCS Channel

   const fetchRcsChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "rcs",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await apiService
        .postData(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          rcstemplates = [];
          const chnlObj = res?.data[0];

          setChannelrcs(res?.data);
        //  setsmsCampaign({ ...smsCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              rcstemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
        
          // let options = {};
          // options = {
          //   place: "tr",
          //   message:"Templates Not Found",
          //   type: "warning",
          //   autoDismiss: 2,
          // };
          // notificationAlertRef?.current?.notificationAlert(options);
        }));
  };


   //Fetching Template by IVR Channel

   const fetchIvrChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "ivr",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await apiService
        .postData(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          ivrtemplates = [];
          const chnlObj = res?.data[0];

          setChannelivr(res?.data);
         // setsmsCampaign({ ...smsCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              ivrtemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          // options = {
          //   place: "tr",
          //   message: "Templates Not Found",
          //   type: "warning",
          //   autoDismiss: 2,
          // };
          // notificationAlertRef?.current?.notificationAlert(options);
        }));
  };

  const changeSender = (data) => {
    sessionStorage.setItem("template", data.label);
    senderids = [];
    const chnl = channel?.filter((item) => item.template == data.value);

    const senderid = chnl[0]?.senderid?.split(",");
    for (let i = 0; i < senderid?.length; i++) {
      senderids.push({ label: senderid[i], value: senderid[i] });
    }

    setsmsCampaign((prev) => ({
      ...prev,
      templateid: data,
      senderid: "",
      message: chnl[0]?.content,
      type: chnl[0]?.sms_type,

    }));
  };

  const fetchSenderId=(data,chnl)=>{
     if(chnl=="Email")
     {
      emailsenderids = [];
      const chnls = channelemail?.filter((item) => item.template == data.value);
      const senderid = chnls[0]?.senderid?.split(",");
      for (let i = 0; i < senderid?.length; i++) {
        emailsenderids.push({ label: senderid[i], value: senderid[i] });
      }
    }
    else if(chnl=="Whatsapp"){
      whatsappsenderids = [];
      const chnls = channelwhatsapp?.filter((item) => item.template == data.value);
      const senderid = chnls[0]?.senderid?.split(",");
      for (let i = 0; i < senderid?.length; i++) {
        whatsappsenderids.push({ label: senderid[i], value: senderid[i] });
      }
    }
    else if(chnl=="RCS"){
      rcssenderids = [];
      const chnls = channelrcs?.filter((item) => item.template == data.value);
      const senderid = chnls[0]?.senderid?.split(",");
      for (let i = 0; i < senderid?.length; i++) {
        rcssenderids.push({ label: senderid[i], value: senderid[i] });
      }
    }
     else if(chnl=="IVR"){
      ivrsenderids = [];
      const chnls = channelivr?.filter((item) => item.template == data.value);
      const senderid = chnls[0]?.senderid?.split(",");
      for (let i = 0; i < senderid?.length; i++) {
        ivrsenderids.push({ label: senderid[i], value: senderid[i] });
      }
    }
   
    

   

    // setsmsCampaign((prev) => ({
    //   ...prev,
    //   templateid: data,
    //   senderid: "",
    //   message: chnl[0]?.content,
    // }));

  }

  const submitWhatsapp = () => {
   
    const isValid = validate();
    setErrorHandle(isValid);

    if (Object.keys(isValid).length == 0) {
 
      setIsLoading(true);
      let slctddate = "";
      if (
        moment(smsCampaign.date).format("YYYY-MM-DD HH:mm") != "Invalid date"
      ) {
        slctddate = moment(smsCampaign.date).format("YYYY-MM-DD HH:mm");
      } else {
        slctddate = smsCampaign.date.slice(0, -2);
      }

      // let payload = {
      //   file: smsCampaign.file,
      //   template: smsCampaign.templateid?.value,
      //   description: smsCampaign.description,
      //   senderid: smsCampaign.senderid?.value,
      //   name: smsCampaign.name,
      //   datetime: moment(slctddate).format("YYYY-MM-DD H:m:ss"),
      //   type: smsCampaign.type,
      //   message: smsCampaign.message,
      //   user_name: localStorage.getItem("username"),
      //   password: localStorage.getItem("password"),
      //   peid: smsCampaign.peid,
      //   client_id: user.client,
      //   priority1: {
      //     channel: smsCampaign?.priority1?.channel||"",
      //     templateid:smsCampaign?.priority1?.templateid?.value||"",
      //     senderid: smsCampaign?.priority1?.senderid?.value||"",
      //   },
      //   priority2: {
      //     channel: smsCampaign?.priority2?.channel||"",
      //     templateid:smsCampaign?.priority2?.templateid?.value||"",
      //     senderid: smsCampaign?.priority2?.senderid?.value||"",
      //   },
      //   priority3: {
      //     channel: smsCampaign?.priority3?.channel||"",
      //     templateid:smsCampaign?.priority3?.templateid?.value||"",
      //     senderid: smsCampaign?.priority3?.senderid?.value||"",
      //   },
      //   priority4: {
      //     channel: smsCampaign?.priority4?.channel||"",
      //     templateid:smsCampaign?.priority4?.templateid?.value||"",
      //     senderid: smsCampaign?.priority4?.senderid?.value||"",
      //   }
      // };

      const payload = new FormData();
      payload.append('name',smsCampaign?.name);
      payload.append('date',moment(slctddate).format("YYYY-MM-DD H:m:ss"));
      payload.append('template',smsCampaign?.templateid?.value);
      payload.append('senderid',smsCampaign.senderid?.value);

      payload.append('priority1',smsCampaign?.priority1?.channel);
      payload.append('priority2',smsCampaign?.priority2?.channel);
      payload.append('priority3',smsCampaign?.priority3?.channel);
      payload.append('priority4',smsCampaign?.priority4?.channel);

      payload.append('templateid1',smsCampaign?.priority1?.templateid?.value);
      payload.append('templateid2',smsCampaign?.priority2?.templateid?.value);
      payload.append('templateid3',smsCampaign?.priority3?.templateid?.value);
      payload.append('templateid4',smsCampaign?.priority4?.templateid?.value);

      payload.append('senderid1',smsCampaign?.priority1?.senderid?.value);
      payload.append('senderid2',smsCampaign?.priority2?.senderid?.value);
      payload.append('senderid3',smsCampaign?.priority3?.senderid?.value);
      payload.append('senderid4',smsCampaign?.priority4?.senderid?.value);

      
      payload.append('message',smsCampaign?.message);
      payload.append('contactgroup',smsCampaign?.contactGroup?.value);
      payload.append('messagetype',smsCampaign?.type);
      payload.append('peid',smsCampaign?.peid);
      payload.append('clientid',user?.client);
      payload.append('username',localStorage?.getItem("username"));
      payload.append('password',localStorage?.getItem("password"));
      if(smsCampaign?.file){
        payload.append('file',smsCampaign?.file);
      }
      



      // payload.append('priority1', JSON.stringify({
      //   channel: smsCampaign?.priority1?.channel||"",
      //   templateid:smsCampaign?.priority1?.templateid?.value||"",
      //   senderid: smsCampaign?.priority1?.senderid?.value||"",
      // }));
      //END
      
     // payload.append('description', smsCampaign?.description);
      
    
      
     
     
    
     
      // payload.append('priority2', JSON.stringify({
      //   channel: smsCampaign?.priority2?.channel||"",
      //   templateid:smsCampaign?.priority2?.templateid?.value||"",
      //   senderid: smsCampaign?.priority2?.senderid?.value||"",
      // }));
      // payload.append('priority3', JSON.stringify({
      //   channel: smsCampaign?.priority3?.channel||"",
      //   templateid:smsCampaign?.priority3?.templateid?.value||"",
      //   senderid: smsCampaign?.priority3?.senderid?.value||"",
      // }));
      // payload.append('priority4', JSON.stringify( {
      //   channel: smsCampaign?.priority4?.channel||"",
      //   templateid:smsCampaign?.priority4?.templateid?.value||"",
      //   senderid: smsCampaign?.priority4?.senderid?.value||"",
      // }));
   

    
      apiService
        .postData(SMS_CAMPEIGN_SAVE, payload)
        .then((response) => {
          setIsLoading(false);
          let options = {};
          options = {
            place: "tr",
            message: "Submitted Successfully",
            type: "success",

            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);

          setsmsCampaign(initialValues);
        })
        .catch((err) => {console.log("err==>", err);
        let options = {};
        options = {
          place: "tr",
          message: err?.response?.data?.message,
          type: "warning",

          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
      }).finally(()=>{
        setIsLoading(false);
      })
    }
  };

  const validate = () => {
    let errors = {};
    const onlylettersRegex = /^[a-zA-Z ]+$/;
    if (!smsCampaign.name) {
      errors.name = "Please Enter Name";
    } else if (smsCampaign?.name?.length <= 3) {
      errors.name = "Please Enter Valid Name";
    } else if (!smsCampaign.name.match(onlylettersRegex)) {
      errors.name = "Please Enter Valid Name";
    }
    if (!smsCampaign?.templateid?.value) {
      errors.templateid = "Please Select Template";
    }
    if (!smsCampaign?.senderid?.value) {
      errors.senderid = "Please Select Sender Id";
    }
    if (!smsCampaign?.type) {
      errors.type = "Please Select Type";
    }
    // if (!smsCampaign?.description) {
    //   errors.description = "Description Required";
    // }
    if (!smsCampaign?.message) {
      errors.message = "Message Required";
    }
    if (!smsCampaign?.file&&!(smsCampaign?.contactGroup)) {
      errors.file = "Please upload file or select group";
    }

    return errors;
  };

  // const chooseFile = (e) => {
  //   var drpdwn = [];
  //   let a = e.target.value.split(".");
  //   const files = e.target.files[0];
  //   filepath = files?.name;
  //   const reader = new FileReader();
  //   reader.readAsDataURL(files);

  //   reader.onload = () => {
  //     //setTextData({ ...textdata, file:reader.result  });
  //   };
  //   if (a[1] == "csv") {
  //     if (files) {
  //       Papa.parse(files, {
  //         complete: (result) => {
  //           result?.data?.map((item, index) => {
  //             if (item.MobileNumber != "") {
  //               drpdwn.push(item);
  //             }
  //           });
  //           setsmsCampaign({ ...smsCampaign, mobile_numbers: drpdwn });
  //         },
  //         header: true,
  //       });
  //     }
  //   } else if (a[1] == "xlsx") {
  //     const reader = new FileReader();

  //     reader.onload = (e) => {
  //       const data = new Uint8Array(e.target.result);
  //       const workbook = XLSX.read(data, { type: "array" });
  //       const sheetName = workbook.SheetNames[0];
  //       const worksheet = workbook.Sheets[sheetName];
  //       const jsonSheet = XLSX.utils.sheet_to_json(worksheet);

  //       if (jsonSheet.length > 0) {
  //         jsonSheet[0]?.map((item, index) => {});
  //       }
  //     };

  //     reader.readAsArrayBuffer(files);
  //   }
  //   setsmsCampaign({ ...smsCampaign, mobile_numbers: drpdwn });
  // };

  const checkvalue = (value, priority) => {
    if (priority == "priority1") {
      if (smsCampaign?.priority2?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority2",
          value,
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority1: { ...preemailCampaign.priority1, channel: "",templateid:"",senderid:"" },
        }));
      } else if (smsCampaign?.priority3?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority3",
          value,
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority1: { ...preemailCampaign.priority1, channel: "",templateid:"",senderid:"" },
        }));
      }else if (smsCampaign?.priority4?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority4",
          value,
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority1: { ...preemailCampaign.priority1, channel: "" ,templateid:"",senderid:""},
        }));
      } else {
        setError({
          iserror: false,
          errorhandle: "",
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority1: { ...preemailCampaign.priority1, channel: value ,templateid:"",senderid:""},
        }));
      }
    } else if (priority == "priority2") {
      if (smsCampaign?.priority1?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority1",
          value,
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority2: { ...preemailCampaign.priority2, channel: "",templateid:"",senderid:"" },
        }));
      } else if (smsCampaign?.priority3?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority3",
          value,
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority2: { ...preemailCampaign.priority2, channel: "" ,templateid:"",senderid:""},
        }));
      } else if (smsCampaign?.priority4?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority4",
          value,
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority2: { ...preemailCampaign.priority2, channel: "",templateid:"",senderid:"" },
        }));
      } else {
        setError({
          iserror: false,
          errorhandle: "",
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority2: { ...preemailCampaign.priority2, channel: value,templateid:"",senderid:"" },
        }));
      }
    } else if (priority == "priority3") {
      if (smsCampaign?.priority1?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority1",
          value,
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority3: { ...preemailCampaign.priority3, channel: "" ,templateid:"",senderid:""},
        }));
      } else if (smsCampaign.priority2.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority2",
          value,
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority3: { ...preemailCampaign.priority3, channel: "" ,templateid:"",senderid:""},
        }));
      } else if (smsCampaign.priority4.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority4",
          value,
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority3: { ...preemailCampaign.priority3, channel: "" ,templateid:"",senderid:""},
        }));
      }
       else {
        setError({
          iserror: false,
          errorhandle: "",
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority3: { ...preemailCampaign.priority3, channel: value ,templateid:"",senderid:""},
        }));
      }
    } else if (priority == "priority4") {
      if (smsCampaign?.priority1?.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority1",
          value,
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority4: { ...preemailCampaign.priority4, channel: "" ,templateid:"",senderid:""},
        }));
      } else if (smsCampaign.priority2.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority2",
          value,
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority4: { ...preemailCampaign.priority3, channel: "" ,templateid:"",senderid:""},
        }));
      }  else if (smsCampaign.priority3.channel == value) {
        setError({
          iserror: true,
          errorhandle: "already exist in priority3",
          value,
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority4: { ...preemailCampaign.priority4, channel: "" ,templateid:"",senderid:""},
        }));
      } 
      
      else {
        setError({
          iserror: false,
          errorhandle: "",
        });
        setsmsCampaign((preemailCampaign) => ({
          ...preemailCampaign,
          priority4: { ...preemailCampaign.priority4, channel: value,templateid:"",senderid:"" },
        }));
      }
    }
  };

  return (
    <>
      <div className="content">
        <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
        <NotificationAlert ref={notificationAlertRef} />
        <Row>
          <Col md="12" className="pt-2">
            <Card>
              <CardBody>
                <Form action="#">
                  <Row>
                    <Col md="4" sm="12">
                      <label>Name *</label>
                      <FormGroup>
                        <Input
                          type="Text"
                          placeholder="Enter Name"
                          value={smsCampaign.name}
                          onChange={(e) =>
                            setsmsCampaign({
                              ...smsCampaign,
                              name: e.target.value,
                            })
                          }
                        />
                      </FormGroup>
                      {errorhandle?.name && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.name}
                        </span>
                      )}
                    </Col>
                    {/* <Col md="4" sm="12">
                      <Label>Description</Label>
                      <Input
                        style={{ padding: "5px" }}
                        type="textarea"
                        name="description"
                        value={smsCampaign?.description}
                        placeholder="Description"
                        onChange={(e) => {
                          setsmsCampaign({
                            ...smsCampaign,
                            description: e.target.value,
                          });
                        }}
                      />
                      {errorhandle?.description && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.description}
                        </span>
                      )}
                    </Col> */}
                    <Col md="4" sm="12">
                      <p className="category">Select Date & Time *</p>
                      <FormGroup>
                        <ReactDatetime
                          inputProps={{
                            className: "form-control",
                            placeholder: "Date & Time",
                          }}
                          closeOnSelect={true}
                          timeFormat={true}
                          value={smsCampaign.date}
                          onChange={(val) =>
                            setsmsCampaign({ ...smsCampaign, date: val._d })
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4" sm="12">
                      <p className="category">
                        Select Template<suf style={{ color: "red" }}>*</suf>{" "}
                      </p>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="templateSelect"
                        value={smsCampaign.templateid}
                        onChange={(value) => changeSender(value)}
                        options={templates}
                        placeholder="Select"
                      />
                      {errorhandle?.templateid && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.templateid}
                        </span>
                      )}
                    </Col>
                   
                    <Col md="4" sm="12">
                      <p className="category">Select Sender</p>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderSelect"
                        value={smsCampaign?.senderid}
                        onChange={(value) =>
                          setsmsCampaign((prev) => ({
                            ...prev,
                            senderid: value,
                          }))
                        }
                        options={senderids}
                        placeholder="Select"
                      />
                      {errorhandle?.senderid && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.senderid}
                        </span>
                      )}
                    </Col>
                    <Col md="4" sm="12">
                      <Label>Message Text</Label>
                      <Input
                       style={{ padding: "5px" ,marginBottom:"0px", resize:"auto",maxHeight:"none" }}
                        type="textarea"
                        name="message"
                        value={smsCampaign?.message}
                        placeholder="Message Text"
                        onChange={(e) => {
                          setsmsCampaign({
                            ...smsCampaign,
                            message: e.target.value,
                          });
                        }}
                      />
                      {errorhandle?.message && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.message}
                        </span>
                      )}
                    </Col>
                    <Col md="4" sm="12">
                    <Label>Message Type</Label>
                      <FormGroup>
                        <Input type="text" disabled="true" value={smsCampaign?.type}/>
                      </FormGroup>
                    </Col>
                    {/* <Col md="3" sm="12">
                      <FormGroup check className="form-check-radio" inline>
                        <Label check>
                          <Input
                            defaultValue="T"
                            id="exampleRadios3"
                            name="exampleRadio"
                            type="radio"
                            value="T"
                            checked={smsCampaign?.type == "T"}
                            onChange={(value) => {
                              setsmsCampaign({ ...smsCampaign, type: "T" });
                            }}
                          />
                          <span className="form-check-sign" />
                          Text Message
                        </Label>
                      </FormGroup>
                      <FormGroup check className="form-check-radio" inline>
                        <Label check>
                          <Input
                            id="exampleRadios4"
                            name="exampleRadio"
                            type="radio"
                            value="U"
                            checked={smsCampaign?.type === "U"}
                            onChange={(value) => {
                              setsmsCampaign({ ...smsCampaign, type: "U" });
                            }}
                          />
                          <span className="form-check-sign" />
                          Unicode
                        </Label>
                      </FormGroup>{" "}
                      {errorhandle?.type && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.type}
                        </span>
                      )}
                    </Col> */}
                      <Col sm="4" className="mb-2 mt-5">
                      <div className="d-flex align-items-center">
                        <span className="mr-2">Group </span>
                        <CustomInput
                          type="switch"
                          id="switch-5"
                          className="mt-n4"
                          checked={ismanual===0?true:false}
                          onChange={(e) =>{
                            e.target.checked==true?setsmsCampaign({...smsCampaign,contactGroup:""}):setsmsCampaign({...smsCampaign,file:""})
                             setIsManual(e.target.checked==true?0:1)
                            }
                            }
                        />
                        <span className="ml-n2">File</span>
                      </div>
                    </Col>
                    {
                        ismanual==0?
                    <Col md="4" sm="12" className="mt-3">
                      <Label>
                        Bulk Upload (<b style={{fontSize:"12px"}}>Upload CSV File</b>)
                      </Label>

                      <FormGroup>
                      <input type="file" accept=".csv"    style={{
                            opacity: "1",
                            position: "initial",
                            border: "solid 1px #eee",
                          }}onChange={(e) => { setFile(e.target.files[0]);
                          setsmsCampaign({...smsCampaign,file:e.target.files[0]})
                          }}/>
                        {/* <Input
                          placeholder="placeholder"
                          type="file"
                          accept=".csv"
                          onChange={(e) => chooseFile(e)}
                          style={{
                            opacity: "1",
                            position: "initial",
                            border: "solid 1px #eee",
                          }}
                        /> */}
                        <a href={SampleCSV} download="SMS Sample File">
                          {" "}
                          <p style={{color: "#e14eca" }}>
                            *Download sample csv file
                          </p>
                        </a>
                      </FormGroup>

                      {errorhandle?.file && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.file}
                        </span>
                      )}
                    </Col>:
                               <Col md="4" sm="12" >
                               <p className="category">Contact Groups</p>
                               <Select
                                 className="react-select info"
                                 classNamePrefix="react-select"
                                 name="groupSelect"
                                 value={smsCampaign.contactGroup}
                                 onChange={(value) => setsmsCampaign({...smsCampaign,contactGroup:value})}
                                 options={groups}
                                 placeholder="Select"
                               />
                               {errorhandle?.file&&<span style={{color:"red"}}>{errorhandle?.file}</span>}
                             </Col>
                    }
                       <Col md="4" className="mb-2 mt-5">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={iscalbck}
                            value={iscalbck}
                            onClick={(e) => {
                              e.target.checked === true
                                ? setiscalbck(true)
                                : setiscalbck(false);
                            }}
                          />
                          <span className="form-check-sign" />
                          Fall back
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  {error.iserror && (
                    <h6 style={{ color: "red" }}>{error.errorhandle}</h6>
                  )}
                  
                  {iscalbck && (
                    <>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="2" className="mb-2 ">
                          <Label>Priority 1</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            // value={.smsSlct}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority1");
                              //setsmsCampaign({...smsCampaign,priority1.channel: value});
                             //  setsmsCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,channel:value}}))
                            }}
                            options={channels}
                            placeholder="Select Channel"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={smsCampaign?.priority1?.templateid}
                            onChange={(value) => {
                              setsmsCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,templateid:value}}))
                            
                               fetchSenderId(value,smsCampaign.priority1.channel)
                            }}
                             options={smsCampaign.priority1.channel=="Whatsapp"?whatsapptemplates:smsCampaign.priority1.channel=="IVR"?ivrtemplates:smsCampaign.priority1.channel=="Email"?emailtemplates:rcstemplates}
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={smsCampaign?.priority1?.senderid}
                        onChange={(value) => {
                          setsmsCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,senderid:value}}))
                        }}
                        options={smsCampaign.priority1.channel=="Whatsapp"?whatsappsenderids:smsCampaign.priority1.channel=="IVR"?ivrsenderids:smsCampaign.priority1.channel=="Email"?emailsenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="2" className="mb-2 ">
                          <Label>Priority 2</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority2");
                              
                              //setsmsCampaign({...smsCampaign,priority1.channel: value});
                               //  setsmsCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,channel:value}}))
                            }}
                           
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={smsCampaign?.priority2?.templateid}
                            onChange={(value) => {
                              setsmsCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,templateid:value}}))
                            
                              fetchSenderId(value,smsCampaign.priority2.channel)
                           
                            }}
                            // options={selectType}
                            options={smsCampaign.priority2.channel=="Whatsapp"?whatsapptemplates:smsCampaign.priority2.channel=="IVR"?ivrtemplates:smsCampaign.priority2.channel=="Email"?emailtemplates:rcstemplates}
                          
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={smsCampaign?.priority2?.senderid}
                        onChange={(value) => {
                          setsmsCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,senderid:value}}))
                        }}
                        options={smsCampaign.priority2.channel=="Whatsapp"?whatsappsenderids:smsCampaign.priority2.channel=="IVR"?ivrsenderids:smsCampaign.priority2.channel=="Email"?emailsenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="2" className="mb-2 ">
                          <Label>Priority 3</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority3");
                              //setsmsCampaign({...smsCampaign,priority1.channel: value});
                             //  setsmsCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,channel:value}}))
                            }}
                           
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={smsCampaign?.priority3?.templateid}
                            onChange={(value) => {
                              setsmsCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,templateid:value}}))
                            
                              fetchSenderId(value,smsCampaign.priority3.channel)
                            }}
                            options={smsCampaign.priority3.channel=="Whatsapp"?whatsapptemplates:smsCampaign.priority3.channel=="IVR"?ivrtemplates:smsCampaign.priority3.channel=="Email"?emailtemplates:rcstemplates}
                          
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={smsCampaign?.priority3?.senderid}
                        onChange={(value) => {
                          setsmsCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,senderid:value}}))
                        }}
                        options={smsCampaign.priority3.channel=="Whatsapp"?whatsappsenderids:smsCampaign.priority3.channel=="IVR"?ivrsenderids:smsCampaign.priority3.channel=="Email"?emailsenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="2" className="mb-2 ">
                          <Label>Priority 4</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority4");
                              //setsmsCampaign({...smsCampaign,priority1.channel: value});
                             //  setsmsCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign.priority4,channel:value}}))
                            }}
                           
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={smsCampaign?.priority4?.templateid}
                            onChange={(value) => {
                              setsmsCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign.priority4,templateid:value}}))
                            
                              fetchSenderId(value,smsCampaign.priority4.channel)
                             }}
                            options={smsCampaign.priority4.channel=="Whatsapp"?whatsapptemplates:smsCampaign.priority4.channel=="IVR"?ivrtemplates:smsCampaign.priority4.channel=="Email"?emailtemplates:rcstemplates}
                          
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={smsCampaign?.priority4?.senderid}
                        onChange={(value) => {
                          setsmsCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign.priority4,senderid:value}}))
                        }}
                        options={smsCampaign.priority4.channel=="Whatsapp"?whatsappsenderids:smsCampaign.priority4.channel=="IVR"?ivrsenderids:smsCampaign.priority4.channel=="Email"?emailsenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                    </>
                  )}
                  <Row>
                    <Col md="1" sm="12">
                      <Button
                        color="primary pull-right"
                        className="mt-4 btn btn-icon animation-on-hover"
                        id="tooltipsubmit"
                        type="button"
                        disabled={isLoading === true && "true"}
                      >
                        <i
                          className="tim-icons icon-double-right"
                          onClick={() => submitWhatsapp()}
                        />
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
          <Col md="3"></Col>
        </Row>
      </div>
    </>
  );
};

export default Mycampaigns;
